import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navegation from './components/navegation/Navegation';
import Footerpage from './components/footerpage/Footerpage';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Navegation />
      <App />
    <Footerpage />
  </React.StrictMode>
);

